/* eslint-disable ember/no-runloop, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import BulkImportStatus from 'linced-app/enums/bulk-import-status';
import { cancel, later } from '@ember/runloop';
import { isEmpty } from '@ember/utils';

export default class ImportController extends Controller {
  @tracked
  checkTimer = null;

  checkImportStatus() {
    this.model.reload().then(() => {
      if (this.model.status === BulkImportStatus.PROCESSING) {
        this.checkTimer = later(this, 'checkImportStatus', 2000);
      }
    });
  }

  cancelTimer() {
    if (!isEmpty(this.checkTimer)) {
      cancel(this.checkTimer);
    }
  }
}
